module.exports = __webpack_public_path__ + "static/img/case_pro2.3f7f8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case_pro2.png
// module id = 5RU8
// module chunks = 1